import React, { Component } from 'react'
import { ah, sh, compose, ReduxWrapper, QueryWrapper } from 'common-data/datahelpers'
import {
  FormBox, WizardBox, WizardBoxItem, WizardBoxSteps, Row, RadioListBox,
  FAIcon, FieldLayoutSizes
} from 'common-controls/Core/index'
import styles from './UpdateAgreement.less'
import { BuildMessageBusEvents } from 'common-tools/index'
import _ from 'common-tools/LodashHelper'

export const UpdateAgreementEvent = BuildMessageBusEvents('Login.UpdateAgreement')

const formName = 'UpdateAgreement'

let updatedAgreements = []

class UpdateAgreementPlain extends Component {
  constructor (props) {
    super(props)

    this.state = {
      initialValues: {},
      UpdateAgreementSteps: []
    }
  }

  async componentDidMount () {
    const { GetUpdatedAgreements, Agreements, formCheckForSubmissionErrors, formStopSubmit } = this.props
    try {
      await GetUpdatedAgreements({ _keys: Agreements })
        .then(({ data }) => {
          const agreementSteps = _.map(data, (agreement) => {
            return `Agreement_${agreement._key}`
          })

          this.setState({
            UpdateAgreementSteps: {
              Notice: 'notice',
              Agreements: agreementSteps,
              Confirm: 'confirm'
            }
          })
        })
    } catch (err) {
      formCheckForSubmissionErrors(err, false)
      formStopSubmit(formName, err)
    }
  }

  onSubmit (values) {
    const { formCheckForSubmissionErrors, showSuccess, close, UpdateAccountAgreements, SessionAccountKey } = this.props

    return UpdateAccountAgreements(
      {
        AccountKey: SessionAccountKey,
        UpdatedAgreements: values.UpdatedAgreements
      }
    ).then(({ data, extra }) => {
      showSuccess(`Thanks, you are good to go!`)
      close([{ Type: UpdateAgreementEvent.Close }, { Type: UpdateAgreementEvent.Success }])
    })
      .catch(formCheckForSubmissionErrors)
  }

  async beforeStepAction (nextStep, previousStep) {
    const { close, formSubmit, data, formStopSubmit, formSetFieldValue, showInfo, showWarning, formDataUpdateAgreement } = this.props

    let errors = {}

    switch (nextStep) {
      case WizardBoxSteps.Done:
        formSubmit(formName)
        break
      case WizardBoxSteps.Cancel:
        close([{ Type: UpdateAgreementEvent.Close }])
        break
    }

    if (previousStep !== this.state.UpdateAgreementSteps.Notice && previousStep !== this.state.UpdateAgreementSteps.Confirm) {
      const agreementKey = _.split(previousStep, '_')[1]

      const agreement = _.filter(data.GetUpdatedAgreementsResults, (item) => {
        return item._key === agreementKey
      })

      if (formDataUpdateAgreement[`${previousStep}_Option`] !== 'I Agree') {
        showInfo(`You'll need to agree to the ${agreement[0].Title} terms and conditions`)
        errors[previousStep] = ` `
      } else {
        let itemExist = _.filter(updatedAgreements, {
          TemplateKey: agreement[0]._key,
          VersionId: agreement[0].CurrentVersion.Id
        })

        if (itemExist.length === 0) {
          updatedAgreements.push(
            {
              TemplateKey: agreement[0]._key,
              VersionId: agreement[0].CurrentVersion.Id
            })
        }

        formSetFieldValue(formName, 'UpdatedAgreements', updatedAgreements)
      }

      formStopSubmit(formName, errors)
    }

    if (_.keys(errors).length > 0) {
      return true
    } else {
      return false
    }
  }

  afterStepAction (nextStep, previousStep) { }

  renderNotice () {
    return (
      <React.Fragment>
        <span className={styles.agreementNotice}>
          <h1>{`We have updated some of our user terms & conditions! `}</h1>
        </span>
        <div className={styles.agreementNoticeIcon}>
          <FAIcon name='file-contract' className={'medium'} color='warning' />
        </div>
      </React.Fragment>
    )
  }

  renderConfirmation () {
    return (
      <React.Fragment>
        <span className={styles.agreementTitle}>
          <h1>{`This will update your Terms & Conditons. Click on the next to finish`}</h1>
        </span>
      </React.Fragment>
    )
  }

  render () {
    const { initialValues } = this.state
    const { data = {} } = this.props

    let agreementItems = []

    if ((this.state.UpdateAgreementSteps.Agreements || []).length > 0) {
      agreementItems.push(
        <WizardBoxItem stepId={this.state.UpdateAgreementSteps.Notice} icon="info-circle" nextStepId={this.state.UpdateAgreementSteps.Agreements[0]}>
          {this.renderNotice()}
        </WizardBoxItem>)

      _.forEach(this.state.UpdateAgreementSteps.Agreements, (agreement, index) => {
        agreementItems.push(
          <WizardBoxItem stepId={this.state.UpdateAgreementSteps.Agreements[index]} icon="handshake"
            nextStepId={index + 1 === this.state.UpdateAgreementSteps.Agreements.length
              ? this.state.UpdateAgreementSteps.Confirm
              : this.state.UpdateAgreementSteps.Agreements[index + 1]}
            previousStepId={index === 0
              ? this.state.UpdateAgreementSteps.Notice
              : this.state.UpdateAgreementSteps.Agreements[index - 1]}>

            <React.Fragment>
              <div className='card'>
                <div className="card-divider">
                  <span className={styles.agreementTitle}>
                    <h1>{data.GetUpdatedAgreementsResults[index].Title}</h1>
                  </span>
                </div>
                <div className="card-section"> {`
                    ${data.GetUpdatedAgreementsResults[index].CurrentVersion.Text}
                  `}
                <div className={styles.agreementOptions}>
                  <Row>
                    <RadioListBox inline layout={FieldLayoutSizes.Seven}
                      name={`Agreement_${data.GetUpdatedAgreementsResults[index]._key}_Option`}
                      options={[{ Value: 'I Agree' }, { Value: 'I Do Not Agree' }]} />
                  </Row>
                </div>
                </div>
              </div>
            </React.Fragment>
          </WizardBoxItem>
        )
      })

      agreementItems.push(
        <WizardBoxItem stepId={this.state.UpdateAgreementSteps.Confirm} icon="check-circle" nextStepId={WizardBoxSteps.Done}
          previousStepId={this.state.UpdateAgreementSteps.Agreements[this.state.UpdateAgreementSteps.Agreements.length - 1]}>
          {this.renderConfirmation()}
        </WizardBoxItem>
      )
    }

    return (
      <FormBox form={formName} simpleBody initialValues={initialValues} onSubmit={this.onSubmit} onChange={this.onChange}>
        {(this.state.UpdateAgreementSteps.Agreements || []).length > 0
          ? <WizardBox afterStepAction={this.afterStepAction} beforeStepAction={this.beforeStepAction} hideNextStepButton={false}
            defaultStepId={this.state.UpdateAgreementSteps.Notice}>
            {agreementItems}
          </WizardBox>
          : null}
      </FormBox>
    )
  }
}

export const UpdateAgreement = compose(
  ReduxWrapper([
    sh.SessionToken,
    sh.SessionAccount,
    sh.FormData(formName, 'formDataUpdateAgreement')
  ], [
    ah.formCheckForSubmissionErrors,
    ah.formSetFieldValue,
    ah.formStopSubmit,
    ah.formSubmit,
    ah.showSuccess,
    ah.showInfo,
    ah.showWarning,
    ah.formStopSubmit
  ]),
  QueryWrapper({
    key: formName,
    actions: [
      {
        url: '/Services/Support/AgreementTemplates/GetCurrentRevisions',
        prop: 'GetUpdatedAgreements',
        map: 'GetUpdatedAgreementsResults'
      },
      {
        url: '/Services/Support/AgreementTemplates/UpdateAccountAgreements',
        prop: 'UpdateAccountAgreements',
        map: 'UpdateAccountAgreementsResults'
      }
    ]
  })
)(UpdateAgreementPlain)

export default UpdateAgreement
